<template>
  <ul class="breadcrumbs flex" :class="{ 'breadcrumbs--light': isLight }">
    <li class="breadcrumbs__item">
      <NuxtLink to="/" class="breadcrumbs__link">
        <NuxtIcon name="IconHome" />
      </NuxtLink>
    </li>

    <li v-for="item in parentSections" :key="`breadcrumbs__${item.slug}`" class="breadcrumbs__item">
      <NuxtLink
        v-if="item.slug"
        :to="{ name: 'home', params: { chapters: useSlugTransform(item.slug) } }"
        class="breadcrumbs__link"
      >
        {{ item.title }}
      </NuxtLink>
    </li>

    <li class="breadcrumbs__item">
      <span class="breadcrumbs__link breadcrumbs__link--current">{{ currentPageName }}</span>
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { ClientBreadcrumbsItem } from '@/types/client/pages';
import './styles.scss';
import { computed, useRuntimeConfig, useRouter, useSlugTransform } from '#imports';
import { useSchemaOrgHead } from '~/composables/useSchemaOrgHead';
import { absoluteUrl } from '~/utils/schemaOrg';

interface Props {
  currentPageName?: string;
  parentSections?: ClientBreadcrumbsItem[];
  isLight?: boolean;
}

const props = defineProps<Props>();
const siteUrl = useRuntimeConfig().public.siteUrl as string;
const route = useRouter().currentRoute;

const breadcrumbItems = computed(() => {
  const parents = props.parentSections || [];
  const items = [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Главная',
      item: absoluteUrl(siteUrl, '/'),
    },
    ...parents.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 2,
      name: item.title,
      item: absoluteUrl(siteUrl, item.slug || ''),
    })),
  ];

  if (props.currentPageName) {
    items.push({
      '@type': 'ListItem',
      position: items.length + 1,
      name: props.currentPageName,
      item: absoluteUrl(siteUrl, route.value.path || '/'),
    });
  }

  return items;
});

useSchemaOrgHead(
  [
    {
      '@type': 'BreadcrumbList',
      itemListElement: breadcrumbItems.value,
    },
  ],
  'schema-org-breadcrumbs',
);
</script>
